import api from './api'

// Sohbet modülü — kanal + DM. Tüm çağrılar company query param alır.
const P = (company, extra = {}) => ({ params: { company, ...extra } })

export const chatService = {
  // Kanal / DM
  listConversations: async (company) => (await api.get('/chat/channels', {
    ...P(company),
    timeout: 12000,
    silentNetToast: true,
  })).data,
  getChannel: async (company, id) => (await api.get(`/chat/channels/${id}`, P(company))).data,
  createChannel: async (company, payload) => (await api.post('/chat/channels', payload, P(company))).data,
  updateChannel: async (company, id, payload) => (await api.put(`/chat/channels/${id}`, payload, P(company))).data,
  deleteChannel: async (company, id) => (await api.delete(`/chat/channels/${id}`, P(company))).data,
  listMembers: async (company, id) => (await api.get(`/chat/channels/${id}/members`, P(company))).data,
  addMembers: async (company, id, userIds) => (await api.post(`/chat/channels/${id}/members`, { user_ids: userIds }, P(company))).data,
  removeMember: async (company, id, userId) => (await api.delete(`/chat/channels/${id}/members/${userId}`, P(company))).data,
  joinChannel: async (company, id) => (await api.post(`/chat/channels/${id}/join`, {}, P(company))).data,
  setFavorite: async (company, id, isFavorite) => (await api.put(`/chat/channels/${id}/favorite`, { is_favorite: isFavorite }, P(company))).data,
  setMuted: async (company, id, isMuted) => (await api.put(`/chat/channels/${id}/mute`, { is_muted: isMuted }, P(company))).data,
  createDm: async (company, userIds) => (await api.post('/chat/dms', { user_ids: userIds }, P(company))).data,
  browseChannels: async (company) => (await api.get('/chat/browse', P(company))).data,
  // Belge sohbeti (doc_thread birleşimi)
  getDocChannel: async (company, doctype, docnum) => (await api.get('/chat/doc-channel', P(company, { doctype: doctype || '_', docnum }))).data,
  ensureDocChannel: async (company, payload) => (await api.post('/chat/doc-channel', payload, P(company))).data,
  adminListChannels: async (company) => (await api.get('/chat/admin/channels', P(company))).data,
  adminDeleteChannel: async (company, id) => (await api.delete(`/chat/admin/channels/${id}`, P(company))).data,

  // Mesajlar
  listMessages: async (company, channelId, opts = {}) => (await api.get(`/chat/channels/${channelId}/messages`, P(company, opts))).data,
  sendMessage: async (company, channelId, payload) => (await api.post(`/chat/channels/${channelId}/messages`, payload, P(company))).data,
  listThread: async (company, messageId) => (await api.get(`/chat/messages/${messageId}/thread`, P(company))).data,
  editMessage: async (company, messageId, body) => (await api.put(`/chat/messages/${messageId}`, { body }, P(company))).data,
  deleteMessage: async (company, messageId) => (await api.delete(`/chat/messages/${messageId}`, P(company))).data,
  toggleReaction: async (company, messageId, emoji) => (await api.post(`/chat/messages/${messageId}/reactions`, { emoji }, P(company))).data,
  assignMessage: async (company, messageId, userId) => (await api.put(`/chat/messages/${messageId}/assign`, { user_id: userId ?? null }, P(company))).data,
  resolveMessage: async (company, messageId, resolved = true) => (await api.post(`/chat/messages/${messageId}/resolve`, { resolved }, P(company))).data,
  pendingScheduled: async (company, channelId) => (await api.get(`/chat/channels/${channelId}/pending-scheduled`, P(company))).data,
  listDrafts: async (company) => (await api.get('/chat/drafts', P(company))).data,
  updateDraft: async (company, messageId, payload) => (await api.put(`/chat/messages/${messageId}/draft`, payload, P(company))).data,
  searchAll: async (company, q) => (await api.get('/chat/search', P(company, { q }))).data,
  forwardMessage: async (company, messageId, payload) => (await api.post(`/chat/messages/${messageId}/forward`, payload, P(company))).data,
  listAssigned: async (company, includeResolved = false) => (await api.get('/chat/assigned', P(company, { include_resolved: includeResolved }))).data,
  // Katıldığım konulardaki yanıtlar (ClickUp 'Replies')
  listReplies: async (company, onlyUnread = false) => (await api.get('/chat/replies', P(company, { only_unread: onlyUnread }))).data,

  // AI
  summarizeChannel: async (company, channelId) => (await api.post(`/chat/channels/${channelId}/summarize`, {}, P(company))).data,

  // Arama / kaydedilenler / mesajdan görev
  searchMessages: async (company, channelId, q) => (await api.get(`/chat/channels/${channelId}/search`, P(company, { q }))).data,
  saveMessage: async (company, messageId, saved = true) => (await api.post(`/chat/messages/${messageId}/save`, { saved }, P(company))).data,
  listSaved: async (company) => (await api.get('/chat/saved', P(company))).data,
  createTaskFromMessage: async (company, messageId, listId) => (await api.post(`/chat/messages/${messageId}/create-task`, { list_id: listId }, P(company))).data,

  // Ekler
  // meta: sesli mesajda { duration_ms, waveform } — diğer eklerde boş geçilir
  uploadAttachment: async (company, messageId, file, meta) => {
    const fd = new FormData()
    fd.append('file', file)
    return (await api.post(`/chat/messages/${messageId}/attachments`, fd, {
      params: { company, ...(meta || {}) },
      headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000,
    })).data
  },
  // Sohbet kilidi (F7) — kişiye özel
  setLocked: async (company, channelId, isLocked) =>
    (await api.put(`/chat/channels/${channelId}/lock`, { is_locked: isLocked }, { params: { company } })).data,
  // Mesajı çevir (F6) — sonuç saklanmaz, okuyucuya özeldir
  translateMessage: async (company, messageId, target = 'tr') =>
    (await api.post(`/chat/messages/${messageId}/translate`, { target }, { params: { company }, timeout: 60000 })).data,
  // ── F5: sabitleme · anket · davet ──
  pinnedMessages: async (company, channelId) =>
    (await api.get(`/chat/channels/${channelId}/pins`, { params: { company } })).data,
  pinMessage: async (company, messageId, { duration = '7d', unpin = false } = {}) =>
    (await api.post(`/chat/messages/${messageId}/pin`, { duration, unpin }, { params: { company } })).data,
  createPoll: async (company, channelId, body) =>
    (await api.post(`/chat/channels/${channelId}/polls`, body, { params: { company } })).data,
  getPoll: async (company, pollId) =>
    (await api.get(`/chat/polls/${pollId}`, { params: { company } })).data,
  votePoll: async (company, pollId, options) =>
    (await api.post(`/chat/polls/${pollId}/vote`, { options }, { params: { company } })).data,
  closePoll: async (company, pollId) =>
    (await api.post(`/chat/polls/${pollId}/close`, {}, { params: { company } })).data,
  createInvite: async (company, channelId, hours = 168) =>
    (await api.post(`/chat/channels/${channelId}/invite`, { hours }, { params: { company } })).data,
  // 'yazıyor…' sinyali — yazarken ~3 sn'de bir; sunucuda kendiliğinden düşer
  sendTyping: async (company, channelId, stop = false) =>
    (await api.post(`/chat/channels/${channelId}/typing`, { stop }, { params: { company } })).data,
  // Kanalın canlı durumu (yazanlar + çevrimiçilik) — tek uç
  channelLive: async (company, channelId) =>
    (await api.get(`/chat/channels/${channelId}/live`, { params: { company } })).data,
  setNotifyLevel: async (company, channelId, level) =>
    (await api.put(`/chat/channels/${channelId}/notify-level`, { level }, { params: { company } })).data,
  // Kanal medya kitaplığı — kind: media | file | audio | links
  channelMedia: async (company, channelId, kind = 'media', limit = 60) =>
    (await api.get(`/chat/channels/${channelId}/media`, { params: { company, kind, limit } })).data,
  // Sesli mesajı metne çevir (F2b). Sonuç sunucuda saklanır — ikinci çağrı ücretsiz.
  transcribeAttachment: async (company, id) =>
    (await api.post(`/chat/attachments/${id}/transcribe`, {}, { params: { company }, timeout: 180000 })).data,
  fetchAttachmentBlob: async (company, id) => (await api.get(`/chat/attachments/${id}`, { params: { company }, responseType: 'blob' })).data,
  // Excel ekinin metni — tarayıcı .xlsx çizemez, sunucu çıkarır (doc_text_service)
  attachmentText: async (company, id) => (await api.get(`/chat/attachments/${id}/text`, P(company))).data,
  deleteAttachment: async (company, id) => (await api.delete(`/chat/attachments/${id}`, P(company))).data,

  // Okunmamış
  markRead: async (company, channelId, messageId) => (await api.post(`/chat/channels/${channelId}/read`, { message_id: messageId ?? null }, P(company))).data,
  markUnread: async (company, channelId, messageId) => (await api.post(`/chat/channels/${channelId}/unread`, { message_id: messageId }, P(company))).data,
  unreadSummary: async (company) => (await api.get('/chat/unread-summary', {
    ...P(company),
    timeout: 10000,
    silentNetToast: true,
  })).data,
  hideChannel: async (company, channelId, hidden = true) => (await api.put(`/chat/channels/${channelId}/hide`, { hidden }, P(company))).data,
  // Gizlenenler — gizlenmiş sohbetleri listeler (geri getirmek için)
  hiddenChannels: async (company) => (await api.get('/chat/hidden', P(company))).data,
  messageReaders: async (company, messageId) => (await api.get(`/chat/messages/${messageId}/readers`, P(company))).data,

  // Yardımcı
  directory: async (company) => (await api.get('/chat/directory', P(company))).data,
  userProfile: async (company, userId) => (await api.get(`/chat/users/${userId}/profile`, P(company))).data,
  mentionSearch: async (company, kind, q, channelId) => (await api.get('/chat/mention-search', P(company, { kind, q: q || '', ...(channelId ? { channel_id: channelId } : {}) }))).data,
  // forDm: DM açma akışı — sunucu firma süzgecini uygulamaz (kanal üyeliğinde uygular).
  searchUsers: async (company, q, opts) => (await api.get('/chat/users/search',
    P(company, { ...(q ? { q } : {}), ...(opts?.forDm ? { for_dm: 1 } : {}) }))).data,
}
